"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SkipOrCloseButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const react_router_dom_1 = require("react-router-dom");
const styled_components_1 = __importStar(require("styled-components"));
const useDiversityOverlay_1 = require("../../hooks/useDiversityOverlay");
const DiversityOverlay_1 = require("../../pages/DiversityOverlay");
function SkipOrCloseButton() {
    const { modelSave, state } = (0, useDiversityOverlay_1.useDiversityOverlay)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const location = (0, react_router_dom_1.useLocation)();
    const isPreview = (location === null || location === void 0 ? void 0 : location.pathname) === DiversityOverlay_1.DiversityRoutes.SettingsPreview;
    const isSkipping = (location === null || location === void 0 ? void 0 : location.pathname) === DiversityOverlay_1.DiversityRoutes.SettingsSkip;
    const onClose = () => {
        modelSave(isSkipping);
        navigate(DiversityOverlay_1.DiversityRoutes.SettingsPreview, { replace: true });
    };
    const onSkip = () => {
        navigate(DiversityOverlay_1.DiversityRoutes.SettingsSkip);
    };
    return ((0, jsx_runtime_1.jsxs)(Container, { "data-e2e": 'SkipOrCloseButton_Container', children: [!isSkipping && !isPreview && (state === null || state === void 0 ? void 0 : state.isOnboarding) && ((0, jsx_runtime_1.jsx)(SkipButton, { onClick: onSkip, "data-e2e": 'SkipOrCloseButton_SkipButton', children: (0, i18n_1.Localized)(i18n_1.Strings.firstLaunchOnboarding.skip) })), !(state === null || state === void 0 ? void 0 : state.isOnboarding) && !isPreview && (0, jsx_runtime_1.jsx)(Close, { onClick: onClose, "data-e2e": 'SkipOrCloseButton_Close' })] }));
}
exports.SkipOrCloseButton = SkipOrCloseButton;
const Container = styled_components_1.default.div `
  display: flex;
  justify-content: flex-end;
`;
const Close = (0, ui_1.withA11y)((0, styled_components_1.default)(ui_1.CloseButton) `
  margin-top: 16px;
  margin-right: 16px;

  /** z-index equals 17 because of Windows @see https://elsevier.atlassian.net/browse/E3D4M-21209  */
  z-index: 17;

  width: 16px;
  height: 16px;

  &:focus {
    outline: ${({ theme }) => theme.greenSecondary} solid 2px;
    outline-offset: 6px;
  }

  &.onMouse:focus {
    outline: none;
  }

  &:focus-visible {
    outline: ${({ theme }) => theme.greenSecondary} solid 2px;
  }

  &:focus:not(:focus-visible) {
    outline: none;
  }
`);
const SkipButton = (0, ui_1.withA11y)((0, styled_components_1.default)(ui_1.FlatButton) `
  box-sizing: border-box;

  margin-top: 22px;
  margin-right: 2px;
  padding: 2px;

  min-width: 60px;
  height: 26px;

  color: ${({ theme }) => theme.settings.text};
  z-index: 1;

  border-radius: 4px;
  ${ui_1.devicePortrait.tablet((0, styled_components_1.css) `
    margin-top: 8px;
    margin-right: 24px;
  `)}

  ${ui_1.deviceLandscape.mobileL((0, styled_components_1.css) `
    margin-top: 12px;
    margin-right: 16px;
  `)}

  ${ui_1.deviceLandscape.laptopS((0, styled_components_1.css) `
    margin-top: 8px;
    margin-right: 24px;
  `)}
`);
